import WarningBanner from 'components/banners/WarningBanner'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import useFlag from 'hooks/useFlag'
import { buildTranslate } from 'locales'
import React from 'react'
import { hasComingSoonPromoPos, hasUnsupportedPromoPos } from './posSupport'

const t = buildTranslate('promo_codes')

type Props = {
  className?: string
}

// Yellow notice on promo-code pages describing in-store promo redemption for
// the merchant's point of sale:
//   - Unsupported POS (Qu, FranPOS, Shift4) -> "in-store isn't available"
//   - Toast (in-store coming soon)          -> "coming soon", unless the
//     merchant is in the `toast-promo-instore-beta` cohort (in-store is live
//     for them, so no banner)
//   - Anything else (e.g. Olo, supported)   -> no banner
//
// Unsupported takes precedence over coming-soon for multi-POS merchants, so the
// message never implies in-store works when at least one of their POS systems
// can't redeem. `className` wraps the banner so callers control spacing without
// leaving an empty node when nothing renders.
const PosRedemptionBanner = ({ className }: Props) => {
  const merchant = useCurrentMerchant()
  const toastInstoreEnabled = useFlag('toast-promo-instore-beta', false)

  let copyKey: string | null = null
  if (hasUnsupportedPromoPos(merchant)) {
    copyKey = 'unsupported_pos_banner'
  } else if (hasComingSoonPromoPos(merchant) && !toastInstoreEnabled) {
    copyKey = 'coming_soon_pos_banner'
  }

  if (!copyKey) return null

  const banner = (
    <WarningBanner
      showIcon
      title={t(`${copyKey}.title`)}
      text={t(`${copyKey}.body`)}
    />
  )

  return className ? <div className={className}>{banner}</div> : banner
}

export default PosRedemptionBanner
